import request from "@/common/request"
import { EstacaoDeImpressao } from "@/models/EstacaoDeImpressao"
import { AxiosRequestConfig } from "axios"

const PATH = '/estacao-de-impressao'

export const createEstacaoDeImpressao = async (estacao: EstacaoDeImpressao): Promise<EstacaoDeImpressao> =>
	await request.post(`${PATH}/cria`, estacao)

export const updateEstacaoDeImpressao = async (estacaoId: string, estacao: EstacaoDeImpressao): Promise<EstacaoDeImpressao> =>
	await request.post(`${PATH}/atualiza/${estacaoId}`, estacao)

export const findEstacoesDeImpressaoPorLoja = async (lojaId: string, apenasAtivas = false, config?: AxiosRequestConfig): Promise<EstacaoDeImpressao[]> =>
	await request.get(`${PATH}/busca-por-loja/${lojaId}`, { params: { apenasAtivas }, ...config })

export const findEstacaoDeImpressaoById = async (estacaoId: string, config?: AxiosRequestConfig): Promise<EstacaoDeImpressao> =>
	await request.get(`${PATH}/busca/${estacaoId}`, { ...config })

export const deleteEstacaoDeImpressao = async (estacaoId: string, config?: AxiosRequestConfig): Promise<void> =>
	await request.delete(`${PATH}/${estacaoId}`, { ...config })
